import {
  ApiResponse,
  CreateOfferingTransactionRequest,
  DateAndAmount,
  OfferingTransaction,
  OfferingTransactionFundStatus,
  OfferingTransactionId,
  PatchOfferingTransactionRequest,
  UserAndReservation,
} from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const postCreateOfferingTransaction = async (request: CreateOfferingTransactionRequest) => {
  const response = await api.post<ApiResponse<OfferingTransaction>>('/trades', request);

  return unwrapApiResponse(response.data);
};

export const getOfferingTransaction = async (offeringTransactionId: OfferingTransactionId) => {
  const response = await api.get<ApiResponse<OfferingTransaction>>(`/trades/${offeringTransactionId}`);

  return unwrapApiResponse(response.data);
};

export const patchOfferingTransaction = async (
  offeringTransactionId: OfferingTransactionId,
  request: PatchOfferingTransactionRequest
) => {
  const response = await api.patch<ApiResponse<OfferingTransaction>>(`/trades/${offeringTransactionId}`, request);

  return unwrapApiResponse(response.data);
};

export const putNCSyncOfferingTransaction = async (offeringTransactionid: OfferingTransactionId) => {
  const response = await api.put<ApiResponse<OfferingTransaction>>(`/trades/${offeringTransactionid}/sync`);

  return unwrapApiResponse(response.data);
};

export const deleteCancelOfferingTransaction = async (offeringTransactionId: OfferingTransactionId) => {
  const response = await api.delete<ApiResponse<OfferingTransaction>>(`/trades/${offeringTransactionId}`);

  return unwrapApiResponse(response.data);
};

export const postSubmitOfferingTransaction = async (offeringTransactionId: OfferingTransactionId) => {
  const response = await api.post<ApiResponse<OfferingTransaction>>(`/trades/${offeringTransactionId}/submit`);

  return unwrapApiResponse(response.data);
};

export const postInitiateOfferingTransactionFundsMovement = async (offeringTransactionId: OfferingTransactionId) => {
  const response = await api.post<ApiResponse<OfferingTransaction>>(`/trades/${offeringTransactionId}/funds/send`);

  return unwrapApiResponse(response.data);
};

export const deleteCancelOfferingTransactionFundsMovement = async (offeringTransactionId: OfferingTransactionId) => {
  const response = await api.delete<ApiResponse<OfferingTransaction>>(`/trades/${offeringTransactionId}/funds/cancel`);

  return unwrapApiResponse(response.data);
};

export const getTradeFundStatuses = async (offeringTransactionId: OfferingTransactionId) => {
  const response = await api.get<ApiResponse<OfferingTransactionFundStatus[]>>(
    `/trades/${offeringTransactionId}/fund-statuses`
  );

  return unwrapApiResponse(response.data);
};

/**
 * Admin Endpoints
 */
export const getAllReservations = async () => {
  const response = await api.get<ApiResponse<UserAndReservation[]>>('/trades/reservations');

  return unwrapApiResponse(response.data);
};

export const getDailyReservations = async () => {
  const response = await api.get<ApiResponse<DateAndAmount[]>>('/trades/reservations/daily');

  return unwrapApiResponse(response.data);
};
